import { combineReducers } from 'redux';
import loginPage from '@/src/application/reducers/loginPage';
import userTracking from '@/src/application/reducers/userTracking';
import homePage from '@/src/application/reducers/homePage';

const rootReducer = combineReducers({
  loginPage,
  userTracking,
  homePage,
});

export default rootReducer;
